import { TeamBadge } from '../../components/TeamBadge';

export function TeamMark({
  code,
  name,
  logo,
  flag = false
}: {
  code: string;
  name: string;
  logo?: string | null;
  flag?: boolean;
}) {
  return (
    <div className="flex flex-1 flex-col items-center gap-[9px]">
      <TeamBadge
        code={code}
        logo={logo}
        name={name}
        flag={flag}
        sizeClass="h-12 w-12"
        roundedClass="rounded-mark"
        textClass="text-[14px]"
        fallback="dark"
        className="shadow-mark"
      />
      <span className="max-w-[88px] truncate text-[12px] font-bold text-white">{name}</span>
    </div>
  );
}
